import { isFormFieldFocusable } from '../../../../utils/forms/isFormFieldFocusable';

// Control types that must never receive auto-focus on form open: radioBtn and
// checkbox per spec — focus skips to the next available field. multiCheckbox and
// reference ARE focusable; the reference quicksearch that would pop on focus is
// suppressed at focus time instead (see openOnFocusSuppression).
const AUTO_FOCUS_SKIPPED_TYPES = new Set(['radioBtn', 'checkbox']);

const resolveFocusable = (wrapper: HTMLElement): HTMLElement | null => {
  // PrimeReact Dropdown's focus target is a readOnly role=combobox input; only
  // `disabled` blocks focus, so readOnly inputs stay eligible. Skip the unfocusable
  // input[type=hidden] aux-inputs Ionic renders.
  const focusable =
    wrapper.querySelector<HTMLElement>(
      'input:not([type="hidden"]), textarea, select, [role="combobox"]'
    ) ?? wrapper.querySelector<HTMLElement>('[tabindex]:not([tabindex="-1"])');

  if (!focusable) {
    return null;
  }

  return isFormFieldFocusable(focusable) ? focusable : null;
};

// First focusable element across the form's fields, in DOM order, skipping the
// types in AUTO_FOCUS_SKIPPED_TYPES.
export const getFirstFocusableFormField = (
  container: HTMLElement
): HTMLElement | null => {
  const wrappers = container.querySelectorAll<HTMLElement>('[data-form-field]');

  for (const wrapper of Array.from(wrappers)) {
    const fieldType = wrapper.dataset.formFieldType;
    if (fieldType && AUTO_FOCUS_SKIPPED_TYPES.has(fieldType)) {
      continue;
    }

    const focusable = resolveFocusable(wrapper);
    if (focusable) {
      return focusable;
    }
  }

  return null;
};
